module.exports = __webpack_public_path__ + "gamecode/img/xdgslg_favicon.png?8a44fb63";